import contactUs from '@/api/contactUs.js'

const state = {
    contactData:{},
    subsidiaries:[],
}

const getters = {
    contactData(state) {
        return state.contactData
    },
    subsidiaries(state) {
        return state.subsidiaries
    },
}

const mutations = {
    setContactState(state, { key, value }) {
        state[key] = value
    },
}

const actions = {
    getContactData({ state, dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            contactUs.contactUs().then((res) => {
                let code = res.data.code;
                if (code == 200) {
                    commit('setContactState', {
                        key: 'contactData',
                        value: res.data.data
                    })
                    resolve(res)
                }
            }).catch((error) => {
                reject(error)
            });
        })
    },
    getSubsidiaries({ state, dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            contactUs.subsidiaries().then((res) => {
                let code = res.data.code;
                if (code == 200) {
                    commit('setContactState', {
                        key: 'subsidiaries',
                        value: res.data.data
                    })
                    resolve(res)
                }
            }).catch((error) => {
                reject(error)
            });
        })
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/contactUs.js